import styled from "styled-components";

export const ContainerButtonVoltar = styled.button`
    padding: 10px;
    color: #FFF;
    background-color: #0055ff;
    border: none;
    border-radius: 10px;
    width: 222px;
    margin-top: 12px ;
    margin-bottom: 12px ;
`;